export const hasMinLength = (value: string | undefined, min: number = 8): boolean =>
    value ? value.length >= min : false;
  
  export const hasNumber = (value: string | undefined): boolean =>
    value ? /\d/.test(value) : false;
  
  export const hasLetter = (value: string | undefined): boolean =>
    value ? /[a-zA-Z]/.test(value) : false;
  